import { CalendarRange, RefreshCcw, LayoutGrid, Lightbulb } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { useSection } from "../../lib/content";

const ICONS = [CalendarRange, RefreshCcw, LayoutGrid, Lightbulb];

export const LongTerm = () => {
  const c = useSection("longTerm");

  return (
    <section id="long-term" className="relative bg-[#1a1a1a] py-28 lg:py-36 overflow-hidden">
      <div className="absolute inset-0 hero-grid-bg opacity-[0.35]" style={{ backgroundImage: "linear-gradient(to right, rgba(148,163,184,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(148,163,184,0.06) 1px, transparent 1px)" }} />
      <div className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full bg-[#024AD8]/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHead dark chapter="05" eyebrow={c.eyebrow} title={c.title} lead={c.lead} />

        <Reveal delay={0.15}>
          <div className="mt-14 rounded-2xl border border-[#FF5050]/25 bg-[#1a1a1a] p-7 lg:p-9 backdrop-blur">
            <p className="font-mono text-xs uppercase tracking-[0.18em] font-semibold text-[#FF5050]">
              {c.supportLabel}
            </p>
            <p className="mt-3 text-slate-300 text-base sm:text-lg leading-relaxed max-w-3xl">
              {c.supportText}
            </p>
            <div className="mt-9 grid sm:grid-cols-4 gap-6">
              {c.timeline.map((t, i) => (
                <div key={t.year} className="relative">
                  <div className="flex items-center gap-3">
                    <span className="w-3 h-3 rounded-full bg-[#FF5050] shadow-[0_0_16px_rgba(255,80,80,0.8)]" />
                    {i < c.timeline.length - 1 && <span className="flex-1 h-px bg-gradient-to-r from-[#FF5050]/60 to-[#FF5050]/10" />}
                  </div>
                  <p className="mt-4 font-display font-extrabold text-white text-2xl tracking-tight">{t.year}</p>
                  <p className="mt-1 text-sm text-slate-400 leading-relaxed">{t.label}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {c.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={item.title} delay={i * 0.1} className="h-full">
                <div className="group h-full rounded-2xl border border-[#2a2a2a] bg-[#1a1a1a] p-7 transition-[background-color,border-color,transform] duration-300 hover:bg-[#222222] hover:border-[#FF5050]/40 hover:-translate-y-1">
                  <Icon className="w-6 h-6 text-[#FF5050]" />
                  <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-white">{item.title}</h3>
                  <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
